import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { BasePricingService } from "shared/cubiq-services/lookup/pricing/impl/BasePricingService";
import { OrdersTableMode } from "shared/cubiq-services/model/OrdersTableMode";
import { ICellRendererAngularComp } from "@bfx/ag-grid-angular";
import { PricingService } from "shared/cubiq-services";
import { EMPTY_AMT_RATE_VALUE } from "../../../shared/cubiq-services/model/BaseTableDefinitionFactory";
import { ICellRendererParams } from "ag-grid-community";

@Component({
  selector: "spot-tracking",
  templateUrl: "./html/SpotTrackingRenderer.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SpotTrackingRenderer implements ICellRendererAngularComp {
  public spotTracking: string;
  public showStrike: boolean;
  public showInvert: boolean;

  constructor(
    public cd: ChangeDetectorRef,
    protected myBasePricingService: BasePricingService,
  ) {}
  // called on init
  agInit(params: ICellRendererParams): void {
    this.doVal(params);
    this.cd.markForCheck();
  }

  doVal(params: ICellRendererParams): boolean {
    let value = params.getValue();
    let changed = false;
    let newSpotTracking;

    if (Number.isNaN(value)) {
      newSpotTracking = EMPTY_AMT_RATE_VALUE;
    } else {
      newSpotTracking = value;
    }

    if (PricingService.isStrikeThroughValue(newSpotTracking)) {
      newSpotTracking = PricingService.clearStrikeThroughString(newSpotTracking);
    }

    if (newSpotTracking != this.spotTracking) {
      changed = true;
      this.spotTracking = newSpotTracking;
    }

    if (this.myBasePricingService) {
      let ndfMode: boolean =
        params.context.mode == OrdersTableMode.NDF_BASE ||
        params.context.mode == OrdersTableMode.NDF_DEALT;
      let pair: CubiqTS.CurrencyPairImpl =
        this.myBasePricingService.ccyPairLookupService.getCcyPair(
          params.data.baseCode,
          params.data.nonBaseCode,
        );

      let strikethrough: boolean =
        ndfMode && pair.ndfEnabledFg
          ? this.myBasePricingService.isStrikethroughNdfTracking(params.data)
          : this.myBasePricingService.isStrikethroughSpotTracking(params.data);

      if (strikethrough) {
        if (this.showStrike == false) {
          changed = true;
        }
        this.showStrike = true;
      } else {
        if (this.showStrike == true) {
          changed = true;
        }
        this.showStrike = false;
      }

      if (
        params.context.mode == OrdersTableMode.NDF_BASE ||
        params.context.mode == OrdersTableMode.BASE
      ) {
        if (params.data.isInvertedOrderFg) {
          this.showInvert = true;
        }
      }
    }

    if (changed) {
      if (params.eGridCell != null) {
        if (this.showStrike)
          if (this.showInvert) params.eGridCell.title = "--- 1/n " + this.spotTracking + " ---";
          else params.eGridCell.title = "--- " + this.spotTracking + " ---";
        else if (this.showInvert) params.eGridCell.title = "1/n " + this.spotTracking;
        else params.eGridCell.title = this.spotTracking;
      }
    }

    return changed;
  }

  // called when the cell is refreshed
  refresh(params: ICellRendererParams): boolean {
    if (this.doVal(params)) {
      this.cd.markForCheck();
    }

    return true;
  }
}
